export type SetupSummary = {
    steps: { [key in SetupStepName]: boolean };
    completed: boolean;
};

export enum SetupStepName {
    DOORS = "doors",
    DELIVERIES = "deliveries",
    SCHEMA = "schema",
}

export enum SetupStepStatus {
    COMPLETE = "complete",
    INCOMPLETE = "incomplete",
}

export enum SetupType {
    MerchantSetupGuide = "merchant_setup_guide",
}

export interface IUpdateSetupStepRequest {
    name: SetupStepName;
    status: SetupStepStatus;
}
